<template>
  <div id="ScalepointContainer">
    <div :id="scalepointViewModel.ScalepointTargetDivId" />
  </div>
</template>

<script>
import Utility from '@/common/UtilityFunctions.js';
import ReportClaimServicesMixin from '@/components/Feature/Claims/flows/ReportClaimServicesMixin.vue';

export default {
  name: 'Scalepoint',
  mixins: [ReportClaimServicesMixin],
  props: {
    scalepointViewModel: {
      type: Object,
      default() {
        return {};
      }
    },
    trackingVm: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  created() {
    this.getScalepointData();
  },
  methods: {
    fail(error) {
      this.dispatchEventObjWithApiError(this.trackingVm, 'claimsection_renewscalepointmodel: ' + error?.message);

      Utility.logError(error, this);
    },
    getScalepointData() {
      return Utility.post(
        Utility.constants().API.claimsection_renewscalepointmodel,
        this.scalepointViewModel,
        this.succes,
        this.fail,
        this
      );
    },
    succes(response) {
      this.$emit('update:modelValue', {
        ScalepointTokenCase: response.data.Data.ScalepointTokenCase,
        ScalepointTokenSso: response.data.Data.ScalepointTokenSso
      });

      const scriptElm = document.createElement('script');
      scriptElm.setAttribute('src', response.data.Data.ScalepointWidgetUrl);
      document.body.appendChild(scriptElm);
    }
  }
};
</script>
